import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetHolsteinMatingBullsAction, matingAction} from '../action';

const tableId = 'matingHolsteinBulls';

function* execute({payload: {tableDataRequest}}: GetHolsteinMatingBullsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getMaleHolsteinAnimalsInList,
        successAction: matingAction.getMaleHolsteinAnimalsSuccess,
        tableId,
    }));
}

/** Saga that handles `mating/GET_MATING_HOLSTEIN_BULLS`. */
export function* getMatingHolsteinBullsSaga(): SagaIterator {
    yield takeLatestF('mating/GET_HOLSTEIN_MATING_BULLS', execute);
}
